module.exports = __webpack_public_path__ + "img/2025-05-09a_7.4a5afb51.jpg";